import { createAction } from '@ngrx/store';

/**
 * Actions für den Time-Deviation-Dialog.
 */
export class TimeDeviationDialogActions {
  private static readonly prefix = '[Dialog Time Deviation]';

  /**
   * Öffnet den Dialog.
   */
  public static open = createAction(
    `${this.prefix} Open dialog`,
  );

  /**
   * Schließt den Dialog.
   */
  public static close = createAction(
    `${this.prefix} Close dialog`,
  );
}
